import { Mail, Heart, Code, Music, Users, Globe, Shield } from 'lucide-react'

function AboutPage() {
  return (
    <div className="page active">
      <div className="container">
        <div className="page-header">
          <div className="page-badge">ℹ️ À PROPOS</div>
          <h1 className="page-title">À Propos</h1>
          <p className="page-subtitle">Radio 100% Johnny 24h/24</p>
        </div>

        {/* Présentation */}
        <div className="glass-card" style={{ marginBottom: '30px', textAlign: 'center' }}>
          <div style={{ fontSize: '4rem', marginBottom: '20px' }}>🎸</div>
          <h2 style={{ fontSize: '2rem', fontWeight: 900, marginBottom: '15px', background: 'linear-gradient(135deg, #00d9ff, #ffd700)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
            Radio 100% Johnny
          </h2>
          <p style={{ fontSize: '1.1rem', lineHeight: 1.8, color: 'rgba(255,255,255,0.8)', maxWidth: '800px', margin: '0 auto' }}>
            La seule radio entièrement dédiée à Johnny Hallyday. Écoutez le meilleur du rock français 24h/24, 7j/7. 
            Découvrez ses plus grands hits, albums mythiques, concerts légendaires et bien plus encore.
          </p>
        </div>

        {/* Notre Mission */}
        <div className="glass-card" style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Music size={28} color="#00d9ff" />
            Notre Mission
          </h2>
          <p style={{ fontSize: '1.1rem', lineHeight: 1.8, color: 'rgba(255,255,255,0.8)' }}>
            Faire vivre l'héritage musical de Johnny Hallyday en proposant une expérience d'écoute unique. 
            Nous nous engageons à partager sa passion, son énergie et son talent avec tous les fans, anciens et nouveaux.
          </p>
        </div>

        {/* Nos Valeurs */}
        <div className="glass-card" style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '25px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Heart size={28} color="#ff1493" />
            Nos Valeurs
          </h2>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
            {[
              { icon: '🎵', title: 'Passion Musicale', desc: 'Partager l\'amour de la musique de Johnny' },
              { icon: '👥', title: 'Communauté', desc: 'Rassembler les fans du monde entier' },
              { icon: '✨', title: 'Qualité', desc: 'Offrir la meilleure expérience d\'écoute' },
              { icon: '🔄', title: 'Innovation', desc: 'Utiliser les meilleures technologies' }
            ].map((value, index) => (
              <div key={index} style={{ padding: '20px', background: 'rgba(255,255,255,0.03)', borderRadius: '15px', border: '1px solid rgba(255,255,255,0.1)', textAlign: 'center' }}>
                <div style={{ fontSize: '3rem', marginBottom: '10px' }}>{value.icon}</div>
                <h3 style={{ fontSize: '1.1rem', fontWeight: 700, marginBottom: '8px', color: '#00d9ff' }}>{value.title}</h3>
                <p style={{ fontSize: '0.95rem', color: 'rgba(255,255,255,0.7)', lineHeight: 1.6 }}>{value.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Fonctionnalités */}
        <div className="glass-card" style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '25px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Code size={28} color="#ffd700" />
            Fonctionnalités
          </h2>

          <div style={{ display: 'grid', gap: '15px' }}>
            {[
              { icon: '📻', title: 'Radio en direct 24/7', desc: 'Écoutez Johnny sans interruption' },
              { icon: '📅', title: 'Événements', desc: 'Concerts, rencontres et célébrations' },
              { icon: '🎙️', title: 'Podcasts', desc: 'Interviews, documentaires et émissions spéciales' },
              { icon: '📰', title: 'Revue de presse', desc: 'Actualités et articles sur Johnny' },
              { icon: '💌', title: 'Dédicaces', desc: 'Envoyez vos messages à vos proches' },
              { icon: '📸', title: 'Galerie photos', desc: 'Souvenirs de nos événements' }
            ].map((feature, index) => (
              <div key={index} style={{ padding: '15px', background: 'rgba(255,255,255,0.03)', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', gap: '15px' }}>
                <div style={{ fontSize: '2.5rem', minWidth: '50px' }}>{feature.icon}</div>
                <div>
                  <h3 style={{ fontSize: '1.1rem', fontWeight: 700, marginBottom: '5px', color: '#00d9ff' }}>{feature.title}</h3>
                  <p style={{ fontSize: '0.9rem', color: 'rgba(255,255,255,0.7)' }}>{feature.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Équipe */}
        <div className="glass-card" style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Users size={28} color="#9333ea" />
            L'Équipe
          </h2>
          <p style={{ fontSize: '1.1rem', lineHeight: 1.8, color: 'rgba(255,255,255,0.8)', textAlign: 'center' }}>
            Radio Johnny est développée et maintenue par une équipe passionnée de fans de Johnny Hallyday, 
            déterminée à faire vivre son héritage musical pour les générations futures.
          </p>
        </div>

        {/* Contact & Support */}
        <div className="glass-card" style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Mail size={28} color="#22c55e" />
            Contact & Support
          </h2>

          <div style={{ display: 'grid', gap: '15px' }}>
            <div style={{ padding: '15px', background: 'rgba(255,255,255,0.03)', borderRadius: '12px' }}>
              <div style={{ fontWeight: 700, marginBottom: '5px', color: '#00d9ff' }}>📧 Email</div>
              <a href="mailto:contact@johnnysjh.fr" style={{ color: 'rgba(255,255,255,0.8)', textDecoration: 'none' }}>
                contact@johnnysjh.fr
              </a>
            </div>
            <div style={{ padding: '15px', background: 'rgba(255,255,255,0.03)', borderRadius: '12px' }}>
              <div style={{ fontWeight: 700, marginBottom: '5px', color: '#00d9ff' }}>🌐 Site Web</div>
              <a href="https://johnnysjh.fr" target="_blank" rel="noopener noreferrer" style={{ color: 'rgba(255,255,255,0.8)', textDecoration: 'none' }}>
                www.johnnysjh.fr
              </a>
            </div>
            <div style={{ padding: '15px', background: 'rgba(255,255,255,0.03)', borderRadius: '12px' }}>
              <div style={{ fontWeight: 700, marginBottom: '5px', color: '#00d9ff' }}>💬 Support</div>
              <p style={{ color: 'rgba(255,255,255,0.8)', margin: 0 }}>
                Disponible du lundi au vendredi, 9h-18h
              </p>
            </div>
          </div>
        </div>

        {/* Mentions légales */}
        <div className="glass-card" style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Shield size={28} color="#ef4444" />
            Mentions Légales
          </h2>

          <div style={{ fontSize: '0.9rem', color: 'rgba(255,255,255,0.7)', lineHeight: 1.8 }}>
            <p style={{ marginBottom: '15px' }}>
              <strong style={{ color: '#00d9ff' }}>Éditeur :</strong> Radio 100% Johnny<br />
              <strong style={{ color: '#00d9ff' }}>Siège social :</strong> France<br />
              <strong style={{ color: '#00d9ff' }}>Email :</strong> contact@johnnysjh.fr
            </p>
            <p style={{ marginBottom: '15px' }}>
              <strong style={{ color: '#00d9ff' }}>Hébergement :</strong><br />
              Firebase (Google Cloud Platform)<br />
              Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA
            </p>
            <p>
              <strong style={{ color: '#00d9ff' }}>Propriété intellectuelle :</strong><br />
              Tous les contenus diffusés sont la propriété de leurs auteurs respectifs. 
              Radio 100% Johnny respecte les droits d'auteur et diffuse uniquement des contenus autorisés.
            </p>
          </div>
        </div>

        {/* Version */}
        <div style={{ textAlign: 'center', padding: '30px 0', color: 'rgba(255,255,255,0.5)' }}>
          <p style={{ fontSize: '0.9rem', marginBottom: '10px' }}>
            Radio 100% Johnny - Version 1.0.0
          </p>
          <p style={{ fontSize: '0.85rem' }}>
            Made with <Heart size={14} color="#ff1493" style={{ verticalAlign: 'middle', display: 'inline' }} /> by fans, for fans
          </p>
          <p style={{ fontSize: '0.8rem', marginTop: '10px' }}>
            © 2024-2026 Radio Johnny. Tous droits réservés.
          </p>
        </div>

      </div>
    </div>
  )
}

export default AboutPage